import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Alert } from 'src/app/interfaces/alert';
import { User } from 'src/app/interfaces/user';
import { AuthManagerService } from 'src/app/services/auth-manager/auth-manager.service';
import { UserService } from 'src/app/services/user/user.service';
import { HelperService } from 'src/app/shared/helpers/helper.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-microchipping-your-pet',
  templateUrl: './microchipping-your-pet.component.html',
  styleUrls: ['./microchipping-your-pet.component.scss']
})
export class MicrochippingYourPetComponent implements OnInit {

  public alert: Alert = null;
  public loading = false;
  public pricingPlans = environment.stripePlans;
  public user: User | null = null;
  public isAuthenticated: boolean;
  public appPriceCardFeatureText: string[] = [
    'Instant email alert when your pet’s chip is scanned',
    '24/7 help & support via our dedicated hotline',
    'Unlimited changes to your details',
    'Annual keeper certificate',
    'Online account access and management',
    'Secure data storage'
  ]
  public appAlertPriceCardFeatureText: string[] = [
    'Instant contact when your missing pet’s chip is scanned',
    '24/7 help & support via our dedicated hotline',
    'Instant, personalised posters & social media posts',
    '20-mile missing pet report broadcast to vets, wardens and police',
    'SMS broadcast to other identi pet keepers in a 5 mile radius',
    'Keep your details up to date in our app so we can contact you faster'
  ];

  constructor(
    private _activatedRoute: ActivatedRoute,
    private _helperService: HelperService,
    private _router: Router,
    private route: ActivatedRoute,
    private userService: UserService,
    private authManager: AuthManagerService,
  ) {}

  ngOnInit(): void {
    this.isAuthenticated = this.authManager.isAuthenticated;
    if (this.isAuthenticated) {
      this.userService.getMe().subscribe((userResponse: User) => {
        this.user = userResponse;
      });
    }

    const queryParams = this._activatedRoute.snapshot.queryParams;

    if (queryParams && queryParams.section) {
      this._helperService.scrollToElementById(queryParams.section);
    }
  }

  public closeAlert() {
    this.alert = null;
  }

  public unauthorizedSelect(planId?: string) {
    switch (planId) {
      case environment.stripePlans.identibasePlus:
        this._router.navigate(['/identibase-plus']);
        break;
      case environment.stripePlans.identiAlertMonthly:
        this._router.navigate(['/identialert']);
        break;
      case environment.stripePlans.identiAlertAnnual:
        this._router.navigate(['/identialert']);
        break;
      case environment.stripePlans.identiAlertFindCat:
        this._router.navigate(['/identifind']);
        break;
      case environment.stripePlans.identiAlertFind:
        this._router.navigate(['/identifind']);
        break;
      default:
        this._router.navigate(['/identialert']);
    }
  }

}
